import React from 'react';

const NotificationPage = () => {
  return <div>NotificationPage</div>;
};

export default NotificationPage;
